export default function ChevronLeftIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 16.5858L10.4142 12.0001L15 7.41426L15 6.00004L15 6L13.5858 6L8.2929 11.293L7.5858 12.0001L8.29291 12.7072L13.5858 18.0001L15 18.0001L15 16.5858Z"
        fill="#3C3C3C"
      />
    </svg>
  );
}
